export function normalizeReviewQueryToken(
  token: string | (string | null)[] | undefined | null,
): string | undefined {
  if (typeof token === 'string' && token.length > 0) {
    return token
  }
  if (Array.isArray(token) && token[0]) {
    return String(token[0])
  }
  return
}
